module.exports = __webpack_public_path__ + "images/external_images/img/380x360/img2.jpg";